/**
 * Blok Export in Instellingen > Meer. L4 van blok L (Frank, 19 oktober 2026).
 *
 * Een zip met je eigen werk in open formaat: gesprekken (JSON en Markdown), projecten,
 * kennisbankdocumenten, geheugen, agents en skills. Deze werkruimte of alles. Er komen
 * geen sleutels of wachtwoorden in; dat bewaakt de backend (`services/export_open.py`).
 * Downloaden gaat zoals elders in de app: een blob en een link met `download`.
 */
import { useState } from "react";
import axios from "axios";
import { Button } from "./ui/button";
import { API } from "@/lib/api";
import { useTaal } from "@/contexts/TaalContext";

/** De bestandsnaam uit Content-Disposition, of een vaste naam. PUUR. */
export function bestandsnaam(kop, bereik) {
  const m = /filename="([^"]+)"/.exec(kop || "");
  return m ? m[1] : `novamund-export-${bereik}.zip`;
}

export default function ExportBlok() {
  const { t } = useTaal();
  const [bezig, setBezig] = useState("");
  const [klaar, setKlaar] = useState("");
  const [fout, setFout] = useState("");

  const exporteer = async (bereik) => {
    setBezig(bereik);
    setKlaar("");
    setFout("");
    try {
      const r = await axios.get(`${API}/settings/export`, { params: { bereik }, responseType: "blob" });
      const naam = bestandsnaam(r?.headers?.["content-disposition"], bereik);
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = naam;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      setKlaar(naam);
    } catch {
      setFout(t("Exporteren is mislukt."));
    } finally {
      setBezig("");
    }
  };

  return (
    <div className="border rounded-lg p-4 space-y-3" data-testid="export-blok">
      <h4 className="font-medium text-sm">{t("Export")}</h4>
      <p className="text-xs text-muted-foreground">
        {t("Een zip met je eigen werk in open formaat: gesprekken als JSON en Markdown, projecten, kennisbankdocumenten, geheugen, agents en skills als JSON. Er staan geen sleutels of wachtwoorden in.")}
      </p>
      <div className="flex flex-wrap gap-2">
        <Button type="button" variant="outline" size="sm" className="h-11 md:h-8" disabled={Boolean(bezig)}
                onClick={() => exporteer("werkruimte")} data-testid="export-werkruimte">
          {bezig === "werkruimte" ? t("Bezig met exporteren...") : t("Exporteer deze werkruimte")}
        </Button>
        <Button type="button" variant="outline" size="sm" className="h-11 md:h-8" disabled={Boolean(bezig)}
                onClick={() => exporteer("alles")} data-testid="export-alles">
          {bezig === "alles" ? t("Bezig met exporteren...") : t("Exporteer alles")}
        </Button>
      </div>
      {klaar && <p className="text-xs" data-testid="export-klaar">{t("Export klaar")}: <span className="font-mono">{klaar}</span></p>}
      {fout && <p className="text-sm text-destructive" role="alert">{fout}</p>}
    </div>
  );
}
